<template>
  <card-container
    :id="pageId"
    :is-loading="isLoading"
    :disabled="isLoading"
    loading-message="Sending Driver Details..."
    @submit="sendDriverDetailsCall"
    @reset="resetForm"
  >
    <template #title>
      Send Driver Details via Call/SMS
    </template>

    <template #content>
      <div class="row align-items-center">
        <label class="col-sm-3 control-label">Caller ID*</label>
        <div class="col-sm-7">
          <sanitized-input
            :id="`callerId-${pageId}`"
            v-model="requestBody.callerId"
            placeholder="Please input caller id"
            required
          />
        </div>
      </div>

      <div class="row align-items-center">
        <label class="col-sm-3 control-label"> Communication Method* </label>
        <div class="col-sm-7">
          <dropdown-list
            v-model="requestBody.communicationMethod"
            :options="communicationMethodList"
          />
        </div>
      </div>

      <div class="row align-items-center">
        <label class="col-sm-3 control-label"> Phone Number </label>
        <phone-number-input
          id="customer-phone"
          v-model="requestBody.phoneNumber"
          class="col-sm-7"
          :page-id="pageId"
          :required="false"
        />
      </div>
    </template>

    <template #submit-button>
      Send Driver Details
    </template>
  </card-container>
</template>

<script lang="ts">
import { ref, Ref, watch } from 'vue';

import util from '@/Utils/util';
import { useCustomer } from '@/use/customer';
import { useSwalDialog } from '@/use/swalDialog';
import { sendPost } from '@/Utils/api';
import { ListType } from '@/models/app';

const pageId = 'send-driver-details';

const communicationMethodList: ListType[] = [
  { id: 1, key: 'call', label: 'Call' },
  { id: 2, key: 'sms', label: 'SMS' },
];

export default {
  name: 'DriverDetailsCall',

  setup: () => {
    const { customerInfo } = useCustomer();
    const { showSuccessPopupDialog, showErrorPopupDialog } = useSwalDialog();

    const requestBody: Ref<any> = ref({
      callerId: '',
      phoneNumber: '',
      communicationMethod: communicationMethodList[0].key,
    });

    const isLoading = ref(false);

    const sendDriverDetailsCall = async () => {
      // if phone number is invalid, init with empty string
      requestBody.value.phoneNumber = util.getValidPhoneNumber(requestBody.value.phoneNumber);

      isLoading.value = true;
      try {
        // POST /sendDriverDetails
        /*
          body => {
            callerId: ***,
            communicationMethod: call or sms
            phoneNumber?: ***,
          }
        */
        await sendPost('sendDriverDetails', requestBody.value);
        showSuccessPopupDialog({
          text: 'The driver details has been sent successfully!',
        });
      } catch (error) {
        const errorText = util.getErrorResponse(error, false);
        showErrorPopupDialog({
          text: errorText,
        });
      }
      isLoading.value = false;
    };

    const resetForm = () => {
      requestBody.value = {
        callerId: '',
        phoneNumber: '',
        communicationMethod: communicationMethodList[0].key,
      };
    };

    watch(
      customerInfo,
      (value: any) => {
        resetForm();
        requestBody.value.callerId = value?.id;
      },
      {
        immediate: true,
      },
    );

    return {
      pageId,
      requestBody,
      isLoading,
      communicationMethodList,

      sendDriverDetailsCall,
      resetForm,
    };
  },
};
</script>
